<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-06 18:01:30
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-17 12:02:24
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\cardItemHeader.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row flex-just-between">
		<div class="flex-row flex-align-center yx-color-text-regular font-h6-regular">
			<el-checkbox v-if="row.tabName !== '2'" :label="row">{{ '' }}</el-checkbox>
			<ButtonGroup :paddingLeft="0">
				<div>
					<span>合作ID</span>
					<span class="ml-4">{{ row.cooperate_id | formatEmpty }}</span>
					<i class="el-icon-copy-document cursor-pointer ml-4" @click="handleCopy(row.cooperate_id)"></i>
				</div>
			</ButtonGroup>
			<ButtonGroup :lineHeight="8">
				<div>
					<span>操作信息</span>
					<span class="ml-4">{{ row.operator_name }}</span>
					<span class="ml-4 mr-4 yx-color-text-placeholder">/</span>
					<span>{{ row.operator_time }}</span>
				</div>
			</ButtonGroup>
			<ButtonGroup :lineHeight="8">
				<div class="flex-row flex-align-center">
					<span>{{ zsName }}</span>
					<el-tooltip placement="top" :content="row.operating_name" v-ak-tooltip-auto-show>
						<span class="line-ellipsis-1 ml-4" style="max-width: 62px">{{ row.operating_name | formatEmpty }}</span>
					</el-tooltip>
				</div>
			</ButtonGroup>
			<ButtonGroup :lineHeight="8">
				<div class="flex flex-align-center fz-12 yx-color-text-primary"
					>团长：<span class="yx-color-text-regular">{{ row.institution_name | formatEmpty | textFormat(8) }}</span>
					<el-tooltip placement="top" :open-delay="300">
						<div slot="content">
							<span>团长ID</span>
							<span class="ml-4">{{ row.authority_id | formatEmpty }}</span>
							<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(row.authority_id)"></i>
						</div>
						<div class="tag-lable radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover">ID</div>
					</el-tooltip>
					<div v-if="statusState" class="authority-status yx-color-text-regular">{{ row.authority_status }}</div>
				</div>
			</ButtonGroup>
			<ButtonGroup :lineHeight="8" v-if="row.tabName !== '0' && row.sample_sn">
				<span class="cursor-pointer yx-color-primary" @click="skipSample(row.cooperate_id)">查看样品订单</span>
			</ButtonGroup>
		</div>
		<div class="flex flex-align-center font-h6-regular">
			<statusDesc v-if="row.order_other_status != 7" :row="row" :btnText="row.other_status_desc" :tabName="row.tabName" />
			<p class="ml-10" v-if="row.close_desc">{{ '(' + row.close_desc + ')' }}</p>
			<p class="ml-10 yx-color-text-primary font-bold" v-if="row.order_other_status_desc">{{ row.order_other_status_desc }}</p>
		</div>
	</div>
</template>
<script>
import ButtonGroup from '@/components/ui/buttonGroup';
import { copy } from '@/utils/common';
import { zsRoleType } from '@/utils/dataMap';
import statusDesc from './statusDesc';
export default {
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	components: {
		ButtonGroup,
		statusDesc,
	},
	computed: {
		zsName() {
			return zsRoleType.name;
		},
		statusState({ row }) {
			return row.authority_status && row.authority_status !== '已授权';
		},
	},
	data() {
		return {};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		skipSample(cooperate_id) {
			const { href } = this.$router.resolve({ path: '/sample/list', query: { cooperate_id } });
			window.open(href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.tag-lable {
	padding: 0 3px;
	height: 17px;
	border-radius: 3px;
	background-color: @color-gy2;
	margin-left: 4px;
}
.authority-status {
	margin-left: 8px;
	line-height: 20px;
	padding: 0 3px 0 3px;
	height: 20px;
	border-radius: 3px;
	border: 1px solid @color-gy4;
	font-size: 12px;
	font-family: PingFangSC-Regular;
}
</style>
